
import { useParams } from 'react-router-dom'

import { IconCellWithAttentionHOC } from './NewCells/IconCellWithAttention'
import React from 'react'


function EmailSendCell2(props) {

  const req = {
    api: `/api/v2/general/export/pdf/${props.cellContent}`,
    method: 'GET'
  }


  return (
    <IconCellWithAttentionHOC req={req} />
  )
}

export default EmailSendCell2